import { Heading } from 'bold-ui'
import { Fragment } from 'react'

import { Carousel, CarouselItem } from '../components/Carousel'
import { NewsGif } from '../components/NewsGif'
import { NewsHeadingSection } from '../components/NewsHeadingSection'
import { NewsImg } from '../components/NewsImg'
import { NewsListItem } from '../components/NewsListItem'
import { NewsSectionContent } from '../components/NewsSectionContent'

export function NewsInternalPanelCincoZero() {
  return (
    <Fragment>
      <NewsHeadingSection title='Acompanhamentos' id='acompanhamentos-5-0'>
        <NewsSectionContent>
          <NewsListItem>
            Nova interface! Agora a lateral do atendimento irá mostrar as informações dos acompanhamentos específicos do
            cidadão. <br /> <br />
          </NewsListItem>
          <Heading level={5}>Acompanhamento da criança:</Heading>
          <NewsListItem>
            Marcos de desenvolvimento integrados ao SOAP, possibilitando que os profissionais consultem outras
            informações durante a avaliação.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-0_acompanhamento_crianca.webm'
            pausedSrc='/static/novidades/5-0_acompanhamento_crianca_paused.png'
            alt='Gif mostrando o acompanhamento da criança'
          />{' '}
          <br />
          <Heading level={4}>Acompanhamento de pré-natal:</Heading>
          <NewsListItem>
            Apresentação de todas as informações que antes estavam na tela de acompanhamento. Risco da gravidez, DPPs,
            IGs, DUM, consultas de pré-natal realizadas e a última consulta odontológica feita durante a gestação serão
            informações acessadas rapidamente pelos profissionais através da lateral.
          </NewsListItem>
          <NewsListItem>Medições antropológicas com as curvas de referência durante a fase de gestação.</NewsListItem>
          <NewsListItem>
            Medições específicas do atendimento de pré-natal apresentadas na modal de medições em uma aba separada
            juntamente com o gráfico de referência de altura uterina.{' '}
          </NewsListItem>
          <Carousel>
            <CarouselItem
              image='/static/novidades/5-0_acompanhamento_pre_natal_soap.webp'
              alt='Acompanhamento de pré-natal no SOAP'
            />
            <CarouselItem
              image='/static/novidades/5-0_acompanhamento_pre_natal_medicoes.webp'
              alt='Acompanhamento de pré-natal nas medições'
            />
            <CarouselItem
              image='/static/novidades/5-0_acompanhamento_pre_natal_card.webp'
              alt='Acompanhamento de pré-natal na barra lateral'
            />
          </Carousel>
          <Heading level={4}>Acompanhamento do idoso:</Heading>
          <NewsListItem>
            Apresentação da data da última avaliação multidimensional feita para os cidadãos com 60 anos ou mais.
          </NewsListItem>
          <NewsListItem>
            Apresentação de um alerta quando 5 ou mais medicamentos de uso contínuo estiverem ativos no cadastro do
            cidadão.
          </NewsListItem>
          <Carousel>
            <CarouselItem
              image='/static/novidades/5-0_acompanhamento_idoso_soap.webp'
              alt='Acompanhamento do idoso no SOAP'
            />
            <CarouselItem
              image='/static/novidades/5-0_acompanhamento_idoso_card.webp'
              alt='Acompanhamento do idoso na barra lateral'
            />
          </Carousel>
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection title='Alergias' id='alergias-5-0'>
        <NewsSectionContent>
          <NewsListItem>
            Nova interface! O módulo foi redesenhado e agora está ainda mais fácil de usar. Confira nas imagens abaixo
            as principais alterações:
          </NewsListItem>
          <Carousel>
            <CarouselItem image='/static/novidades/5-0_alergia_antes.webp' alt='Módulo de alergias antigo' />
            <CarouselItem image='/static/novidades/5-0_alergia_depois.webp' alt='Módulo de alergias novo' />
          </Carousel>
          <NewsListItem>
            O bloco para registrar a evolução de alergias estará sempre disponível na Avaliação do SOAP.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-0_alergia.webm'
            pausedSrc='/static/novidades/5-0_alergia_paused.webp'
            alt='Gif da avaliação de alergias'
          />{' '}
          <br />
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection title='Antecedentes' id='antecedentes-5-0'>
        <NewsSectionContent>
          <NewsListItem>
            Nova interface! O módulo foi redesenhado e agora está ainda mais fácil de usar. Confira nas imagens abaixo
            as principais alterações:
          </NewsListItem>
          <Carousel>
            <CarouselItem
              image='/static/novidades/5-0_antecedentes_antes.webp'
              alt='antecedentes nas versões antigas'
            />
            <CarouselItem image='/static/novidades/5-0_antecedentes_depois.webp' alt='antecedentes na nova versão' />
          </Carousel>
          <NewsListItem>
            Nova forma de cadastrar os antecedentes pessoais. Agora, o registro dos antecedentes é direto na Lista de
            Problemas e Condições através do botão "Adicionar antecedente resolvido".
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-0_antecedentes_pessoal.webm'
            pausedSrc='/static/novidades/5-0_antecedentes_pessoal_paused.png'
            alt='gif mostrando os antecedentes pessoais'
          />{' '}
          <br />
          <NewsListItem>
            Antecedentes familiares em uma área exclusiva, com novo campo de observações para cada registro.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-0_antecedentes_familiar.webm'
            pausedSrc='/static/novidades/5-0_antecedentes_familiar_paused.png'
            alt='gif mostrando os antecedentes familiares'
          />{' '}
          <br />
          <NewsListItem>
            Novo grupo de antecedentes hospitalares para cadastro de cirurgias e internações, com novos campos para data
            e idade.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-0_antecedentes_cirurgias.webm'
            pausedSrc='/static/novidades/5-0_antecedentes_cirurgias_paused.png'
            alt='gif mostrando os antecedentes hospitalares'
          />{' '}
          <br />
          <NewsListItem>
            Novo botão para acompanhamento da criança, exibido após o cidadão completar 19 anos. Antes, ao atingir essa
            idade, a informação não era mais acessível. Agora, é possível através dos antecedentes.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-0_antecedentes_acompanhamento.webm'
            pausedSrc='/static/novidades/5-0_antecedentes_acompanhamento_paused.png'
            alt='gif mostrando o acompanhamento da criança'
          />{' '}
          <br />
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection title='Atendimentos' id='atendimentos-5-0'>
        <NewsSectionContent>
          <NewsListItem>
            Nova interface com estrutura de informações na lateral do atendimento! Facilita o acesso à informações do
            prontuário que podem ser relevantes durante um atendimento. <br />
            São agrupadas em: Alergias/Reações adversas, Problemas/condições, Medições e gráficos, Medicamentos em uso,
            Lembretes, Resultados de exames, Condições autorreferidas e Acompanhamentos de pré-natal, do idoso e da
            criança.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-0_atendimento_estrutura.webm'
            pausedSrc='/static/novidades/5-0_atendimento_estrutura_paused.webp'
            alt='Gif mostrando a nova estrutura da tela de Atendimento'
          />{' '}
          <br />
          <NewsListItem>
            Pesquisa na Avaliação de problemas e condições que estão ativos ou latentes na Lista de Problema/Condições
            do cidadão, facilitando o registro da evolução.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-0_atendimento_pesquisa.webm'
            pausedSrc='/static/novidades/5-0_atendimento_pesquisa_paused.webp'
            alt='Gif mostrando as novas opções de pesquisa durante um atendimento'
          />{' '}
          <br />
          <NewsListItem>
            Visualização das listas de Problemas e Condições e de Alergias/Reações adversas do cidadão no Atendimento de
            Procedimentos.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-0_atendimento_procedimentos.webm'
            pausedSrc='/static/novidades/5-0_atendimento_procedimentos_paused.png'
            alt='Gif mostrando o novo Atendimento de Procedimentos'
          />{' '}
          <br />
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection title='Atendimento odontológico' id='atendimento-odonto-5-0'>
        <NewsSectionContent>
          <NewsListItem>
            Nova interface! O módulo está em um novo formato, que une a Evolução Odontológica do sistema antigo com a
            inserção de Problemas e Condições nos dentes. Confira nas imagens abaixo as principais alterações:
          </NewsListItem>
          <Carousel>
            <CarouselItem image='/static/novidades/5-0_odonto_arcada_antes.webp' alt='Arcada antiga' />
            <CarouselItem image='/static/novidades/5-0_odonto_arcada_depois.webp' alt='Arcada nova' />
            <CarouselItem image='/static/novidades/5-0_odonto_dentes_antes.webp' alt='Dentes antigo' />
            <CarouselItem image='/static/novidades/5-0_odonto_dentes_depois.webp' alt='Dentes novo' />
            <CarouselItem image='/static/novidades/5-0_odonto_sextante_antes.webp' alt='Sextante antigo' />
            <CarouselItem image='/static/novidades/5-0_odonto_sextante_depois.webp' alt='Sextante novo' />
            <CarouselItem image='/static/novidades/5-0_odonto_outros_antes.webp' alt='Outros antigo' />
            <CarouselItem image='/static/novidades/5-0_odonto_outros_depois.webp' alt='Outros novo' />
            <CarouselItem image='/static/novidades/5-0_odonto_tecidos_molese_duros.webp' alt='Tecidos moles e duros' />
            <CarouselItem
              image='/static/novidades/5-0_odonto_registro_periodontal_simplificado.webp'
              alt='Registro periodontal simplificado'
            />
          </Carousel>
          <NewsListItem>Novos campos "Possui aparelho" e "Possui contenção";</NewsListItem>
          <NewsListItem>
            Botão "Mostrar dentes decíduos" para ativar ou desativar a visualização dos dentes;
          </NewsListItem>
          <NewsListItem>
            Registro de procedimentos em dentes supranumerários através de um botão abaixo do odontograma;
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-0_odonto_odontograma.webm'
            pausedSrc='/static/novidades/5-0_odonto_odontograma_paused.webp'
            alt='Gif do registro de dentes supranumerarios no odontograma'
          />{' '}
          <br />
          <NewsListItem>
            Nova aba "Tecidos duros e moles", onde é possível fazer a análise de outras parte da boca que não sejam os
            dentes;
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-0_odonto_tecidos_moles.webm'
            pausedSrc='/static/novidades/5-0_odonto_tecidos_moles_paused.webp'
            alt='Gif da nova aba de tecidos moles e duros'
          />{' '}
          <br />
          <NewsListItem>
            Nova aba "Periodontia", onde é possível fazer o Registro de procedimentos para sextantes, Registro
            Periodontal Simplificado e Periograma Completo.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-0_odonto_periograma_completo.webm'
            pausedSrc='/static/novidades/5-0_odonto_periograma_completo_paused.webp'
            alt='Gif da nova aba de periodontia'
          />{' '}
          <br />
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection title='Atestados' id='atestados-5-0'>
        <NewsSectionContent>
          <NewsListItem>
            Nova interface! O módulo foi redesenhado e agora está ainda mais fácil de usar. Confira nas imagens abaixo
            as principais alterações:
          </NewsListItem>
          <Carousel>
            <CarouselItem image='/static/novidades/5-0_atestado_padrao_antes.webp' alt='Atestado padrão antigo' />
            <CarouselItem image='/static/novidades/5-0_atestado_padrao_depois.webp' alt='Atestado padrão novo' />
            <CarouselItem image='/static/novidades/5-0_atestado_branco_antes.webp' alt='Atestado em branco antigo' />
            <CarouselItem image='/static/novidades/5-0_atestado_branco_depois.webp' alt='Atestado em branco novo' />
          </Carousel>
          <NewsListItem>
            Cadastro de modelos de atestado para otimizar o tempo dos profissionais que usam atestados diferentes do
            modelo padrão.
          </NewsListItem>
          <Carousel>
            <CarouselItem
              image='/static/novidades/5-0_atestado_modelo_cadastro.webp'
              alt='Cadastro de modelo de atestado'
            />
            <CarouselItem image='/static/novidades/5-0_atestado_modelo_exemplo.webp' alt='Exemplo de atestado modelo' />
          </Carousel>
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection title='Encaminhamentos e orientações' id='encaminhamento-orientacoes-5-0'>
        <NewsSectionContent>
          <NewsListItem>
            Nova interface! Os módulos foram redesenhados e agora está ainda mais fácil de usar. Confira nas imagens
            abaixo as principais alterações:
          </NewsListItem>
          <Carousel>
            <CarouselItem image='/static/novidades/5-0_orientacoes_antes.webp' alt='Orientacoes antigo' />
            <CarouselItem image='/static/novidades/5-0_orientacoes_depois.webp' alt='Orientacoes novo' />
            <CarouselItem image='/static/novidades/5-0_encaminhamentos_antes.webp' alt='Encaminhamentos antigo' />
            <CarouselItem image='/static/novidades/5-0_encaminhamentos_depois.webp' alt='Encaminhamentos novo' />
          </Carousel>
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection title='Escuta inicial / pré-atendimento' id='escuta-inicial-5-0'>
        <NewsSectionContent>
          <NewsListItem>
            Nova interface! O módulo foi redesenhado e agora está ainda mais fácil de usar. Confira nas imagens abaixo
            as principais alterações:
          </NewsListItem>
          <Carousel>
            <CarouselItem image='/static/novidades/5-0_escuta_inicial_antes.webp' alt='Escuta inicial antiga' />
            <CarouselItem image='/static/novidades/5-0_escuta_inicial_depois.webp' alt='Escuta inicial nova' />
            <CarouselItem image='/static/novidades/5-0_escuta_inicial_antes_2.webp' alt='Escuta inicial antiga' />
            <CarouselItem image='/static/novidades/5-0_escuta_inicial_depois_2.webp' alt='Escuta inicial nova' />
          </Carousel>
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection title='Exames' id='exames-5-0'>
        <NewsSectionContent>
          <NewsListItem>
            Nova interface! O módulo foi redesenhado e agora está ainda mais fácil de usar. Confira nas imagens abaixo
            as principais alterações:
          </NewsListItem>
          <Carousel>
            <CarouselItem image='/static/novidades/5-0_exames_resultado_antes.webp' alt='Resultado de exames antigo' />
            <CarouselItem image='/static/novidades/5-0_exames_resultado_depois.webp' alt='Resultado de exames novo' />
            <CarouselItem
              image='/static/novidades/5-0_exames_solicitar_comum_antes.webp'
              alt='Solicitação de exame comum antigo'
            />
            <CarouselItem
              image='/static/novidades/5-0_exames_solicitar_comum_depois.webp'
              alt='Solicitação de exame comum novo'
            />
            <CarouselItem
              image='/static/novidades/5-0_exames_solicitar_alto_custo_antes.webp'
              alt='Solicitação de alto custo antigo'
            />
            <CarouselItem
              image='/static/novidades/5-0_exames_solicitar_alto_custo_depois.webp'
              alt='Solicitação de alto custo novo'
            />
            <CarouselItem image='/static/novidades/5-0_exames_solicitados_antes.webp' alt='Exame solicitado antigo' />
            <CarouselItem image='/static/novidades/5-0_exames_solicitados_depois.webp' alt='Exame solicitado novo' />
            <CarouselItem image='/static/novidades/5-0_exames_historico_antes.webp' alt='Histórico de exames antigo' />
            <CarouselItem image='/static/novidades/5-0_exames_historico_depois.webp' alt='Histórico de exames novo' />
          </Carousel>
          <NewsListItem>
            No histórico de solicitações de exames, é possível imprimir uma solicitação em até 30 dias e replicar todos
            os exames de uma solicitação antiga.
          </NewsListItem>
          <NewsListItem>
            Os resultados de exames com e sem solicitação são registrados no mesmo local. A interface foi otimizada para
            inserir todos os resultados de exames no mesmo momento.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-0_exames_registro_resultado.webm'
            pausedSrc='/static/novidades/5-0_exames_registro_resultado_paused.webp'
            alt='Gif da mostrando os resultados de exames'
          />{' '}
          <br />
          <NewsListItem>
            O histórico de resultados de exames está localizado no menu lateral e permite a comparação de vários
            resultados do mesmo exame;
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-0_exames_historico_registros.webm'
            pausedSrc='/static/novidades/5-0_exames_historico_registros_paused.webp'
            alt='Gif mostrando o histórico de resultados de exame'
          />{' '}
          <br />
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection title='Histórico clínico do cidadão' id='historico-5-0'>
        <NewsSectionContent>
          <NewsListItem>
            Nova interface! O módulo foi redesenhado para facilitar a visualização dos diversos tipos de históricos e
            das principais informações indicadas pelos profissionais através de etiquetas (tags), sem ser necessário
            abrir os detalhamentos de cada histórico.
          </NewsListItem>
          <Carousel>
            <CarouselItem image='/static/novidades/5-0_historico_antes.webp' alt='Histórico antigo' />
            <CarouselItem image='/static/novidades/5-0_historico_depois.webp' alt='Histórico novo' />
          </Carousel>
          <NewsListItem>
            Implementação de novos filtros para a localização mais refinada dos históricos dos atendimentos.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-0_historico_filtros.webm'
            pausedSrc='/static/novidades/5-0_historico_filtros_paused.webp'
            alt='Gif dos filtros do histórico'
          />{' '}
          <br />
          <NewsListItem>
            Otimização na performance do sistema ao trazer os resultados na listagem do histórico clínico.
          </NewsListItem>
          <NewsListItem>Impressão individual e em lote do histórico, facilitando sua ação.</NewsListItem>
          <NewsGif
            src='/static/novidades/5-0_historico_impressao.webm'
            pausedSrc='/static/novidades/5-0_historico_impressao_paused.webp'
            alt='Gif da impressão de histórico'
          />{' '}
          <br />
          <NewsListItem>
            Visualização do detalhamento de cada histórico com design que facilita a leitura das informações,
            disponibilizadas na própria listagem ao expandir o item.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-0_historico_visualizacao.webm'
            pausedSrc='/static/novidades/5-0_historico_visualizacao_paused.png'
            alt='Gif da visualização do histórico'
          />{' '}
          <br />
          <NewsListItem>Exclusão de um atendimento do tipo Vacinação.</NewsListItem>
          <NewsGif
            src='/static/novidades/5-0_historico_exclusao.webm'
            pausedSrc='/static/novidades/5-0_historico_exclusao_paused.webp'
            alt='Gif da exclusão de histórico'
          />{' '}
          <br />
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection title='Medicamentos' id='medicamentos-5-0'>
        <NewsSectionContent>
          <NewsListItem>
            Nova interface! O módulo foi redesenhado e agora está ainda mais fácil de usar. Confira nas imagens abaixo
            as principais alterações:
          </NewsListItem>
          <Carousel>
            <CarouselItem image='/static/novidades/5-0_medicamentos_antes.webp' alt='Medicamentos antigo' />
            <CarouselItem image='/static/novidades/5-0_medicamentos_depois.webp' alt='Medicamentos novo' />
          </Carousel>
          <NewsListItem>
            Impressão pode ser realizada na mesma tela que está sendo prescrito o medicamento, sendo possível imprimir
            todos medicamentos daquela receita com um único clique.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-0_medicamentos_impressao.webm'
            pausedSrc='/static/novidades/5-0_medicamentos_impressao_paused.webp'
            alt='Gif da impressão de medicamentos'
          />{' '}
          <br />
          <NewsListItem>
            Histórico das prescrições exibido na listagem em um único lugar com um design mais prático e moderno.
          </NewsListItem>
          <NewsListItem>
            Pesquisa de um medicamento já prescrito, com opção de incluir os medicamentos de uso contínuo.{' '}
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-0_medicamentos_pesquisa.webm'
            pausedSrc='/static/novidades/5-0_medicamentos_pesquisa_paused.png'
            alt='Gif da pesquisa de medicamentos'
          />{' '}
          <br />
          <NewsListItem>Interrupção de um tratamento, bem como cancelar a interrupção. </NewsListItem>
          <NewsGif
            src='/static/novidades/5-0_medicamentos_interrupcao.webm'
            pausedSrc='/static/novidades/5-0_medicamentos_interrupcao_paused.webp'
            alt='Gif da interrupção de um tratamento'
          />{' '}
          <br />
          <NewsListItem>
            Replicação do receituário completo ou apenas de um medicamento prescrito em uma receita.{' '}
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-0_medicamentos_replicar.webm'
            pausedSrc='/static/novidades/5-0_medicamentos_replicar_paused.webp'
            alt='Gif da replicação de uma receita'
          />{' '}
          <br />
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection title='Pré-natal / puerpério' id='pre-natal-5-0'>
        <NewsSectionContent>
          <NewsListItem>
            Nova interface! O módulo foi redesenhado e agora está ainda mais fácil de usar. Confira nas imagens abaixo
            as principais alterações:
          </NewsListItem>
          <Carousel>
            <CarouselItem image='/static/novidades/5-0_pre_natal_antes.webp' alt='Pre-natal nas versões antigas' />
            <CarouselItem image='/static/novidades/5-0_pre_natal_depois.webp' alt='Pre-natal na nova versão' />
          </Carousel>
          <NewsListItem>
            Pré-natal só pode ser iniciado a partir da avaliação do SOAP. Condições de pré-natal lançadas diretamente na
            Lista de Problemas/Condições não são consideradas como Atendimento Individual com pré-natal.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-0_pre_natal_novo.webm'
            pausedSrc='/static/novidades/5-0_pre_natal_novo_paused.png'
            alt='Gif do novo pre-natal'
          />{' '}
          <br />
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection title='Prontuário / folha de rosto' id='prontuario-5-0'>
        <NewsSectionContent>
          <NewsListItem>
            Nova interface! O módulo foi redesenhado e agora está ainda mais fácil de usar. Confira nas imagens abaixo
            as principais alterações:
          </NewsListItem>
          <Carousel>
            <CarouselItem image='/static/novidades/5-0_folha_rosto_antes.webp' alt='Folha de rosto antiga' />
            <CarouselItem image='/static/novidades/5-0_folha_rosto_depois.webp' alt='Folha de rosto nova' />
          </Carousel>
          <NewsListItem>
            Através de cards, visualização de informações de Escuta Inicial/Pré-atendimento, Últimos contatos,
            Antecedentes, Medições, Vacinação, Problemas/Condições autorreferidas, Lembretes, Alergias/Reações adversas,
            Lista de problemas/condições, Resultados de exames, Medicamentos. Os cards são clicáveis e exibem mais
            informações ao serem abertos.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-0_folha_rosto_atendimento.webm'
            pausedSrc='/static/novidades/5-0_folha_rosto_atendimento_paused.webp'
            alt='Gif da folha de rosto durante o atendimento'
          />{' '}
          <br />
          <NewsListItem>
            Acesso à Folha de Rosto, Histórico e Vacinação a partir da visualização do prontuário. Na Folha de Rosto da
            visualização do prontuário há também informações do Plano, incluindo as evoluções odontológicas.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-0_folha_rosto_prontuario.webm'
            pausedSrc='/static/novidades/5-0_folha_rosto_prontuario_paused.webp'
            alt='Gif da folha de rosto durante a visualização do prontuario'
          />{' '}
          <br />
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection title='Vacinação' id='vacinacao-5-0'>
        <NewsSectionContent>
          <NewsListItem>Nova funcionalidade de aprazamento automático de doses.</NewsListItem>
          <NewsGif
            src='/static/novidades/5-0_vacinacao_aprazamento.webm'
            pausedSrc='/static/novidades/5-0_vacinacao_aprazamento_paused.png'
            alt='Gif do aprazamento automático de doses'
          />{' '}
          <br />
          <NewsListItem>Visualização de informações da vacina na folha de rosto.</NewsListItem>
          <NewsImg
            src='/static/novidades/5-0_vacina_folha_rosto.webp'
            alt='Imagem da visualização de informações de vacina na folha de rosto'
          />{' '}
          <br />
        </NewsSectionContent>
      </NewsHeadingSection>
    </Fragment>
  )
}
